
import { Component, Prop, Vue } from "vue-property-decorator";
import DescribeData from "@/views/paper/paper-result-report/component-new-h5/describe.vue";
import LevelDetail from "@/views/paper/paper-result-report/component-new-h5/level-detail.vue";
import H5ReportDialog from "@/views/paper/paper-result-report/component-new-h5/dialog/index.vue";

import { official } from "./config";
import * as echarts from "echarts";
import { TacPsycGauge } from "@/lib/model/exam/candidate-result";

type EChartsOption = echarts.EChartsOption;

@Component({ components: { DescribeData, LevelDetail, H5ReportDialog } })
export default class Psychological extends Vue {
  @Prop({ type: TacPsycGauge, default: () => new TacPsycGauge() })
  psyGauge!: TacPsycGauge;
  centerDialogVisible: Boolean = false;

  get targetDisc(): any {
    const target = {
      data: {},
      list: [] as number[]
    };
    target.list = this.psyGauge.psycGaugeResult.dimensionEvaluateList.map(
      item => {
        return Number(item.evaluateResult);
      }
    );
    if (target.list.length) {
      this.$nextTick(() => {
        this.echartLine(target.list);
      });
    }
    target.data =
      official[this.psyGauge.psycGaugeResult.questionnaireEvaluate.result[0]];
    console.log("target: ", target);
    return target;
  }
  // Echarts折线图
  echartLine(list: number[]): void {
    const BLUE = "#1576FF"; // 横纵坐标的颜色 颜色要改
    const BLUE_LIGHT = "#1576FF33"; // 浅蓝
    const chartDom = document.getElementById("line") as HTMLElement;
    if (!chartDom) return;
    const myChart = echarts.init(chartDom, undefined, { renderer: "svg" });
    const option = {
      grid: {
        left: "0%",
        right: "0%",
        top: "5%",
        bottom: "5%",
        containLabel: true // 计算位置时考虑坐标轴标签的大小
      },
      xAxis: {
        type: "category",
        data: ["D", "I", "S", "C"],
        axisTick: {
          show: false
        },
        axisLabel: {
          fontWeight: "bold",
          color: BLUE,
          lineHeight: 19
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: BLUE_LIGHT
          }
        }
      },
      yAxis: {
        type: "value",
        max: 100,
        splitLine: {
          lineStyle: {
            color: BLUE_LIGHT
          }
        },
        axisLine: {
          lineStyle: {
            color: BLUE_LIGHT
          }
        },
        axisLabel: {
          formatter: function(val: number) {
            return val + "%";
          },
          color: BLUE,
          // fontWeight: "bold",
          fontSize: 12,
          lineHeight: 19
        }
      },
      series: [
        {
          data: list,
          type: "line",
          symbolSize: 12,
          symbol: "circle",
          itemStyle: {
            color: BLUE,
            borderWidth: 2,
            borderColor: "#fff"
          },
          cursor: "default"
        }
      ]
    } as EChartsOption;
    option && myChart.setOption(option);
  }

  // 展示指引
  showReading(): void {
    this.centerDialogVisible = true;
  }
}
